import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { Heading, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { TextRenderer } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/RichTextField/TextRenderer";
import { useParseStyles } from "../../../Design/useParseStyles";
import { defaultStyles } from "./defaultStyles";

interface H1Props extends ComponentPropsWithRef<"table"> {
  blockPath: string;
  "data-preview-mode": boolean;
  styles?: Record<string, StyleValue>;
  text: string;
}

const baseStyles = {
  letterSpacing: defaultStyles.letterSpacing,
} as const;

export const H1 = forwardRef<HTMLTableElement, H1Props>(
  (
    {
      text,
      styles = {},
      blockPath,
      "data-preview-mode": isPreviewMode,
      ...rest
    },
    ref,
  ) => {
    const inlineStyles = useParseStyles({
      baseStyles,
      styles,
      defaultStyles,
    });

    return (
      <Section ref={ref} {...rest}>
        <Heading as="h1" style={inlineStyles}>
          <TextRenderer
            blockPath={blockPath}
            text={text}
            isPreviewMode={isPreviewMode}
          />
        </Heading>
      </Section>
    );
  },
);

H1.displayName = "H1";
